import { fork } from "redux-saga/effects";

import performanceSaga from "../performanceSaga";

export default function* performanceRootSaga() {
  yield fork(performanceSaga);
}
